import theme, { createStyles, ThemeColors } from 'core/utilities/theme';
import { RULER_PIXEL_HEIGHT } from 'sequenceAnalyser/utilities/screen/screen';

export default createStyles({
  root: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    height: `${RULER_PIXEL_HEIGHT}px`,
    borderBottom: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    borderTop: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    backgroundColor: theme.palette.background.default,
    zIndex: 1100,
  },
  sidebar: {
    position: 'sticky',
    left: 0,
    height: `${RULER_PIXEL_HEIGHT}px`,
    display: 'inline-block',
    zIndex: 2,
    verticalAlign: 'bottom',
    borderRight: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    backgroundColor: theme.palette.background.default,
  },
  ruler: {
    mt: '6px',
  },
});
